export const pt = {
    title: `Editar perfil`,
    updated: `Perfil atualizado com sucesso!`,
    save: `Salvar alterações`,
    saving: `Salvando...`,
    failure: `Falha ao atualizar o perfil`,
};
//# sourceMappingURL=pt.js.map